@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.shipment-object-header {
  height: 31px;
  display: flex;
  border-bottom: 1px solid @shipment-object-header--border-color;
}

.actions-dropdown-wrapper {
  border-left: 1px solid @shipment-object-header--actions-dropdown--border-color;
  min-width: 31px;
}

.actions-dropdown-button {
  height: 30px;
  width: 30px;
  cursor: pointer;

  &:hover {
    svg {
      fill: @shipment-object-header--actions-dropdown-button--hover--fill-color;
    }
  }

  svg {
    height: 100%;
    width: 100%;
    padding: 7px;
    fill: @shipment-object-header--actions-dropdown-button--fill-color;
  }
}
